<div class="membership-benefits container">
  <div class="membership-benefits-content">
    <h3 class="membership-benefits-title text-white font-heading mb-0">
      {{ 'home.page.membership.benefits.title' | translate : { fgbdefault: 'Membership Benefits' } }}
    </h3>
    <p class="membership-benefits-desc text-white mb-0">
      {{
        'home.page.membership.benefits.description'
          | translate
            : {
                fgbdefault:
                  'Join us for an exciting and comprehensive training session featuring our inaugural team experience. This unique event offers you the opportunity to gain hands-on skills and valuable insights directly from our pioneering group, helping you enhance your abilities and collaborate more effectively in a team environment.'
              }
      }}
    </p>
    <ng-container *inProductCode="[productCode.Free]">
      <a class="membership-benefits-cta rounded fw-bold" [routerLink]="['/membership']">
        {{ 'membership.upgrade.banner.cta' | translate : { fgbdefault: 'Upgrade Now' } }}
      </a></ng-container
    >
  </div>
  <div class="membership-benefits-video" *ngIf="video$ | async as video">
    <fgb-worksheet-item
      [worksheetItem]="video.item"
      [worksheetId]="video.worksheetId"
      [isPlaying]="true"
      [muted]="true"
    ></fgb-worksheet-item>
  </div>
</div>
